module.exports = __webpack_public_path__ + "img/pd-img2.0090a319.png";